<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import Login from 'components/Login'
import * as mutationTypes from 'store/mutationTypes'
import eventBus from 'lib/eventBus'
import ROUTE_NAMES from 'constants/routeNames'
import store from 'src/store'

export default {
  name: 'chat-app-login',
  components: {
    Login,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      venue: (state) => state.venue.current,
      date: (state) => state.date.current,
    }),
  },
  data() {
    return {
      ROUTE_NAMES,
      startOnSignUp: this.$route.query.signup,
    }
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SET_CURRENT_USER) {
        if (this.loggedIn) {
          this.$router.push({
            name: ROUTE_NAMES.CHAT_APP_HOME,
          })
        }
      }
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    if (this.loggedIn) {
      this.$router.push({
        name: ROUTE_NAMES.CHAT_APP_HOME,
      })
    }
  },
  updated() {
    eventBus.$emit('updated')
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/Chat/ChatAppLogin/index.vue